import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
/**
 * Loading placeholder. Hidden from assistive technology: mark the loading
 * region with aria-busy="true" and announce completion separately.
 */
export function Skeleton({ shape = 'rect', width, height, className, style, ...rest }) {
    return (_jsx("div", { ...rest, "aria-hidden": true, className: cx('mn-skeleton', className), "data-shape": shape, style: { width, height, ...style } }));
}
//# sourceMappingURL=skeleton.js.map